import { render, staticRenderFns } from "./pageResult.vue?vue&type=template&id=ab536196&scoped=true&"
import script from "./pageResult.vue?vue&type=script&lang=js&"
export * from "./pageResult.vue?vue&type=script&lang=js&"
import style0 from "./pageResult.vue?vue&type=style&index=0&id=ab536196&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab536196",
  null
  
)

export default component.exports